const agreeClassname = 'user-agreed';
const mainAdd2CartBtn = document.querySelector('.product-form__buttons button[type="submit"], button.product-form__submit[type="submit"]');
const warningPopupRoot = document.getElementById('warningpop__root');
const productAdd2CartForm = document.querySelector(`form[action="/cart/add"]`);
window.show_delivery_warning = localStorage.getItem('delivery_warning_accepted') === 'yes' ? false : true;
let shouldShowPopup = window.currentProductTags && window.currentProductTags.includes('Subscription Box');
if (!shouldShowPopup && window.location.pathname === '/collections/build-a-box') {
  shouldShowPopup = true;
}


// show it every time? or save it in local storage?
const showWarningPopup = (event, add2CartBtn) => {
    if (!add2CartBtn.classList.contains(agreeClassname)) {
        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        // show popup
        warningPopupRoot.style.display = 'block';
    } else {
        warningPopupRoot.style.display = 'none';
    }
}

if (productAdd2CartForm && shouldShowPopup) {
    productAdd2CartForm.addEventListener('submit', (event) => {
        showWarningPopup(event, mainAdd2CartBtn);
    });
}

console.log({ mainAdd2CartBtn });
if (mainAdd2CartBtn && shouldShowPopup) {
    mainAdd2CartBtn.addEventListener('click', (event) => {
        showWarningPopup(event, event.currentTarget);
    });
}

document.querySelector('#warning-agree')?.addEventListener('click', (event) => {
    mainAdd2CartBtn.classList.add(agreeClassname);
    // localStorage.setItem('delivery_warning_accepted', 'yes');
    mainAdd2CartBtn.click();
});

document.querySelector('#warning-disagree')?.addEventListener('click', (event) => {
    warningPopupRoot.style.display = 'none';
    // localStorage.setItem('delivery_warning_accepted', 'no');
});